module.exports = __webpack_public_path__ + "static/media/code-icon.47784e9e.svg";